import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/** Rich tenant config from GET /api/ui/config (server-driven — not persisted). */
export interface AppConfigState {
  brand: string;
  /** Uploaded brand logo URL (Settings → logo); empty = clients use their built-in logo. */
  logo: string;
  terminology: Record<string, string>;
  enabledScreens: string[];
  landing: string;
}

/** Restaurant defaults so nav gating + labels work before the config loads. */
const initialState: AppConfigState = {
  brand: 'ThaliOS',
  logo: '',
  terminology: {},
  enabledScreens: ['tables', 'kot', 'qr-dine-in', 'reservations', 'recipes-bom', 'riders'],
  landing: ''
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig(state, action: PayloadAction<Partial<AppConfigState>>) {
      Object.assign(state, action.payload);
    }
  }
});

export const { setConfig } = configSlice.actions;
export default configSlice.reducer;
